import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function CommonAccordion(props) {
  const {
    title,
    children,
    arrowClass = "!w-4 text-black stroke-normal",
    accordionClass = "",
    summaryClass = "",
    detailsClass = "",
    summaryTypographyClass = "",
    detailTypographyClass = "",
    showSeparator = false,
    expand = false,
  } = props;
  return (
    <Accordion
      sx={{
        ...accordionClass,
      }}
      defaultExpanded={expand}
    >
      <AccordionSummary
        expandIcon={<ChevronDownIcon className={arrowClass} />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={summaryClass}
      >
        <Typography sx={summaryTypographyClass} component="span">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={detailsClass}>
        {showSeparator && (
          <div
            className="my-2 border-t border-gray-300"
            style={{ width: "100%" }}
          />
        )}
        <Typography sx={detailTypographyClass} className="flex">
          {children}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
}

export default CommonAccordion;
